import { I18n } from "app-core";
function zMsg(key, params) {
  return () => params ? I18n.t(key, params) : I18n.t(key);
}
export {
  zMsg as default,
  zMsg
};
//# sourceMappingURL=index60.js.map
